import * as angular from 'angular';

import { Inject, Injectable, Optional, SkipSelf } from "@angular/core";
import { downgradeInjectable } from "@angular/upgrade/static";

import { PendingRequestsInterceptor } from '../interceptors/pending-requests.interceptor';

@Injectable({
	providedIn: 'root'
})
export class PendingRequestsService {
	constructor( //
		@Inject(PendingRequestsInterceptor) private interceptor: PendingRequestsInterceptor, //
		@Optional() @SkipSelf() previousInstance?: PendingRequestsService //
	) {
		if (previousInstance) {
			throw new Error(
				'This service is already loaded. Import it in the AppModule only');
		}
	}
	
	get pendingRequests(): number {
		return this.interceptor.pendingRequests;
	}
}

angular
	.module('auroraApp')
	.service('pendingRequestsService', downgradeInjectable(PendingRequestsService));